import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import styles from '../styles'
import snippetObj from '../snippetObj'
import Grid from '@material-ui/core/Grid'
import { pasteSnippet } from 'actions/template'
import language from 'utils/vast-languagepack'
// import Button from 'components/theme/Button'
import {
	DragIndicator,
	Title,
	Remove,
	Notes,
	Code,
	Link,
	RadioButtonChecked as RadioButton,
	Image,
	Share,
	VerticalSplit,
	ViewColumn,
	Satellite,
} from '@material-ui/icons'
import { DragSource } from 'react-dnd'
import classNames from 'classnames'
import * as themes from '../themes/'

const componentObj = {
	Title,
	Remove,
	Notes,
	Link,
	RadioButton,
	Image,
	Share,
	VerticalSplit,
	ViewColumn,
	Satellite,
	Code,
}

const Snippet = ({
	classes,
	connectDragSource,
	snippet,
	pasteSnippet,
	isDragging,
	disabled,
}) => {
	const component = (
		<span
			id={`${snippet.text}-draggableSnippet`}
			style={{
				opacity: isDragging ? 0.4 : 1,
				borderRadius: 35,
				transform: 'translate(0, 0)',
			}}
			className={
				disabled
					? classNames(classes.taskDisabled, 'draggableSnippet')
					: classNames(classes.task, 'draggableSnippet')
			}
			onClick={() => pasteSnippet(snippet)}
			title={snippet.text}
			data={snippet.text}
		>
			<span>
				{icons(`${snippet.icon}`)}
				{snippet.text}
				<DragIndicator
					className={classNames(
						classes.taskIcon,
						disabled ? classes.dragIconDisabled : classes.dragIcon,
					)}
				/>
			</span>
		</span>
	)

	return connectDragSource ? connectDragSource(component) : component
}

const DndSnippet = DragSource(
	(props) => props.type,
	{
		beginDrag: (props) => {
			// console.log(props)
			return { snippet: props.snippet }
		},
		canDrag: (props) => !props.disabled,
	},
	(connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}),
)(Snippet)

export const icons = (icon) => {
	const Icon = componentObj[icon] || Code
	return <Icon style={{ marginRight: 5, marginBottom: '-7px', fontSize: 22 }} />
}

export default connect(
	(state) => {
		const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
		const disabled = Boolean(
			(stats && automationTypeSelected !== 'stage') ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return { themeSelected: state.email.themeSelected, disabled }
	},
	(dispatch) => bindActionCreators({ pasteSnippet }, dispatch),
)(
	withStyles(styles)(
		({
			classes,
			toggleSnippetsPanel,
			pasteSnippet,
			mobile,
			themeSelected,
			disabled,
		}) => {
			const themeSnippets =
				(themeSelected &&
					themes[themeSelected] &&
					themes[themeSelected].snippets) ||
				{}

			const snippets = Object.values({ ...snippetObj, ...themeSnippets })

			return (
				<Grid style={{ padding: mobile ? 12 : 0 }} container>
					<Grid item xs={12}>
						<Typography>{language.task.add.snippets.description}</Typography>
					</Grid>
					<Grid item xs={12}>
						{snippets.map((snippet) => {
							return (
								<DndSnippet
									type="snippet"
									pasteSnippet={pasteSnippet}
									key={`snippetButton${snippet.text}`}
									classes={classes}
									snippet={snippet}
									disabled={disabled}
								/>
							)
						})}
					</Grid>
				</Grid>
			)
		},
	),
)
